<div
  role="Container do logo da e-retail"
  class="d-flex justify-content-center align-items-center eretail-logo__container"
>
        <img
        [src]="'assets/instances-config/' + instanceName + '/layout/visual-identity/images/little-logo.png'"
        alt="Logo da E-retail"
        [hidden]="isLoading" 
        />

</div>
<mat-progress-spinner [hidden]="isLoading"  diameter="60" [mode]="'indeterminate'"></mat-progress-spinner>